











































import { EntityStatus } from '@adobe/edex/ui/shared/frontend/utils/types';
import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';

const getInitialState = (initialCourse) => ({
  course_id: initialCourse.course_id,
  course_type: initialCourse.course_type,
  title: initialCourse.title,
  locale: initialCourse.locale,
  status: initialCourse.status,
  published_type: initialCourse.published_type,
  aem_id: initialCourse.aem_id,
  vanity_url: initialCourse.vanity_url,
  staff: initialCourse.staff,
  EntityStatus,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  methods: {
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    status(current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'status',
          data: current,
          hasDiff: this.initialCourse.status !== current,
        });
      }
    },
    title(current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'title',
          data: current,
          hasDiff: this.initialCourse.title !== current,
        });
      }
    },
  },
};
